import { pluginRegistry } from "@flow/frontend/member/plugin_api";
import { DonateAction_def } from "../../common/action_types";
import { DonateAction } from "./DonateAction";

pluginRegistry.registerActionComponent(DonateAction_def, (props) => {
  return <DonateAction {...props} />;
});
